<template>
    <component :is="picker" v-if="picker" v-bind="$attrs" :age-restriction-label="ageRestrictionLabel" :embedded="embedded" @unavailable="$emit('unavailable')" />
    <SessionPickerSkeletonV2 v-else-if="!failed" :age-restriction-label="ageRestrictionLabel" :embedded="embedded" />
</template>

<script>
import {markRaw} from "vue";
import SessionPickerSkeletonV2 from "./SessionPickerSkeletonV2.vue";

export default {
    name: "EventV2SessionPickerLoader",
    components: {SessionPickerSkeletonV2},
    inheritAttrs: false,
    props: {
        ageRestrictionLabel: {type: String, default: ""},
        embedded: {type: Boolean, default: false},
    },
    emits: ["unavailable"],
    data() {
        return {picker: null, failed: false};
    },
    async created() {
        try {
            const {default: picker} = await import(/* webpackChunkName: "event-v2" */ "./SessionPickerV2.vue");
            this.picker = markRaw(picker);
        } catch {
            this.failed = true;
            this.$emit("unavailable");
        }
    },
};
</script>
